import styled from 'styled-components';

// styles
export const MainWrapper = styled.div`
    padding-bottom: 160px;
    width: 100%;
    height: auto;
`
export const Loading = styled.div`
    margin-top: 60px;
`

export const LoaderWrapper = styled.div`
   width: 100%;
   display: flex;
   flex-direction: column;
   align-items: center;
   margin: 20px 0;
`

export const SettingWrapper = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;;
    justify-content: flex-start;
    gap: 30px;
    margin-top: 7px;
    @media (max-width: 600px) {
        width: 100%;
    }
    .logout {
        width: 100%;
        border: 1px solid red;
        background: white;
        color: red;
        margin-top: 5px;
    }
    .items {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;;
        justify-content: flex-start;
        gap: 20px;
    }
    .item {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    .label {
        color: #201E67;
        font-size: 16px;
        font-weight: 500;
        display: flex;
        flex-direction: row;
        align-items: flex-start;;
        justify-content: flex-start;
        gap: 7px;
        @media (max-width: 600px) {
            font-size: 15px;
        }
    }
    .icon {
        color: #201E67;
        width: 16px;
        height: 16px;
    }
    
`

export const AppointmentsWrapper = styled.div`
    width: 700px;
    margin: auto;
    margin-top: 30px;
    @media (max-width: 800px) {
        width: 100%;
    }
    .title {
        font-size: 23px;
        font-weight: 700;
        width: 300px !important;
        @media (max-width: 600px) {
            font-size: 20px;
        }
    }
    .column-flex {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
        width: 100%;
        margin-top: 30px;
    }
    .row-flex {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        width: 100%;
        @media (max-width: 555px) {
            flex-direction: column;
            gap: 0px !important;
            justify-content: center !important;
        }
    }
    .red-circle {
        display: block;
        width: 4px;
        height: 4px;
        background: red;
        border-radius: 50%;
        margin-top: -6px;
        margin-right: 2px;
    }
    .header {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 20px;
        border-bottom: 1px solid #bdbdbd;
        padding-bottom: 20px;
    }
    .filtering {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 5px;
        background: white;
        box-shadow: 0px 1px 8px rgba(0,0,0,0.25);
        padding: 0 18px;
        height: 50px;
        width: 50% !important;
        border-radius: 10px;
        cursor: pointer;
        font-size: 16px;
        font-weight: 400;
        border: 1px solid #E5E7EB;
        margin-top: 25px;
        @media (max-width: 600px) {
            font-size: 15px;
        }
        &:hover {
            border: 1px solid gray;
        }
        ${p => p.dir === 'ltr' && `
            direction: ltr;
        `}
        @media (max-width: 555px) {
            width: 100% !important;
        }
    }
    .no-appt {
        display: block;
        font-size: 19px;
        font-weight: 700;
        margin-top: 50px;
        @media (max-width: 600px) {
            font-size: 17px;
        }
    }
    .app-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: auto;
        background: white;
        padding: 10px 20px;
        border-radius: 12px;
        gap: 4%;
        @media (max-width: 800px) {
            flex-direction: column;
            gap: 16px;
            padding: 10px 16px;
        }
        .detail {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            width: 48%;
            @media (max-width: 800px) {
                width: 100%;
                gap: 5px;
            }
        }
        .name {
            font-size: 14px;
            font-weight: 600;
            color: black;
            @media (max-width: 600px) {
                font-size: 13px;
            }
        }
        .service {
            font-size: 14px;
            font-weight: 500;
            color: black;
            @media (max-width: 600px) {
                font-size: 13px;
            }
        }
        .date {
            font-size: 14px;
            font-weight: 400;
            color: black;
            @media (max-width: 600px) {
                font-size: 13px;
            }
        }
        .pay-button-container {
            width: 65%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 5px;
            .pay-button {
                display: block !important;
                width: 100%;
            }
            .desc {
                font-size: 11px;
                font-weight: 400;
                color: black;
                width: auto;
                @media (max-width: 600px) {
                    font-size: 10px;
                }
            }
        }
        .pending {
            color: #60A5FA;
            border: 1px solid #60A5FA;
            width: 65%;
        }
        .paid {
            color: #29BCAB;
            border: 1px solid #29BCAB;
            width: 65%;
        }
        .canceled {
            color: red;
            border: 1px solid red;
            width: 65%;
        }
        .pay {
            width: 65%;
        }
        .buttons {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            justify-content: flex-end;
            gap: 10px;
            width: 48%;
            @media (max-width: 800px) {
                width: 100%;
            }
        }
        .button {
            padding: 0 15px;
            border-radius: 8px;
            text-align: center !important;
            line-height: 48px;
            height: 48px;
        }
        .call {
            color: white;
            background-color: #4DD8C7; 
            width: 65%;
        }
        .view-button {
            background: white;
            border: 1px solid #61788E;
            color: #61788E;
            font-weight: 700;
            text-align: center;
            height: 48px;
            line-height: 48px;
            width: 35%;
        }
    }
`

export const PaymentWrapper = styled.div`
    width: 464px;
    background-color: white;
    border-radius: 24px;
    margin: auto;
    margin-top: 30px;
    height: auto;
    padding: 40px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    @media (max-width: 600px) {
        width: 100%;
        padding: 20px 12px;
    }
    .files-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        gap: 8px;
    }
    .files {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
        gap: 8px;
    }
    .file {
        width: 100%;
        font-weight: 500;
        color: #000000;
        font-size: 12px;
        text-align: left;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        gap: 3px;
        @media (max-width: 270px) {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
        &:hover {
            color: #29BCAB;
            .download-icon {
                color: #29BCAB;
            }
        }
    }
    .icon {
        width: 20px;
        height: 20px;
        color: #0D2439;
        cursor: pointer;
    }
    .delete-icon {
        &:hover {
            color: red;
        }
    }
    .space-between {
        justify-content: space-between !important;
        width: 100%;
    }
    .upload-file {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 10px;
        height: 64px;
        border: 1px solid #CBCBCB;
        border-radius: 14px;
        cursor: pointer;
        border-style: dashed;
        p {
            color: #757575;
        }
    }
    .upload-file-desc {
        font-size: 13px;
        line-height: 26px;
        margin: -1px 0;
        color: #201E67;
        @media (max-width: 600px) {
            font-size: 12px;
        }
    }
    .uploaded-files-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 20px;
        height: auto;
        border-radius: 14px;
        background-color: #F5F5F5;
        padding: 16px;
    }
    .uploaded-label {
        color: #000000;
        font-size: 14px !important;
        border-bottom: 1px solid #CBCBCB;
        padding-bottom: 10px;
        width: 100%;
        span {
            color: #757575;
            font-size: 12px !important;
        }
    }
    .row-flex {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 5px;
        @media (max-width: 435px) {
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
        }
    }
    .badge {
        color: #0053FE;
        font-size: 12px;
        font-weight: 700;
        background-color: #DBEAFE;
        border-radius: 4px;
        padding: 4px 12px !important;
        @media (max-width: 600px) {
            font-size: 11px;
        }
        @media (max-width: 361px) {
            font-size: 10px;
        }
        @media (max-width: 320px) {
            font-size: 8px;
        }
    }
    .paid-badge {
        color: #065F46;
        background-color: #D1FAE5;
    }
    .purple-badge {
        color: #53487C;
        background-color: #E8DEF8;
    }
    .text-header {
        color: #29BCAB;
        font-size: 18px;
        font-weight: 700;
        line-height: 32px
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 5px;
        @media (max-width: 600px) {
            font-size: 17px;
        }
    }
    .buttons {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        .button {
            width: 100%;
            text-align: center !important;
            line-height: 48px;
            height: 48px;
            border-radius: 8px;
        }
        .call {
            color: white;
            background-color: #4DD8C7;
        }
        .app-download {
            border: 1px solid #201E67;
            background: #201E67;
            color: white;
            font-size: 15px;
            font-weight: 700;
	        @media (max-width: 600px) {
                font-size: 14px;
            }
        }
        .payment-section {
            width: 100%;
            .button {
                margin-top: 24px;
            }
            p {
                font-size: 13px;
                text-align: center;
            }
        }
        .paid {
            color: #29BCAB;
            border: 1px solid #29BCAB;
        }
        .pending {
            color: #60A5FA;
            border: 1px solid #60A5FA;
        }
        .canceled {
            color: red;
            border: 1px solid red;
        }
        .link {
            border: 1px solid #61788E;
            color: #61788E;
            background: white;
        }
        .upload {
            color: white;
            background: #201E67;
        }
        .mobile-app-desc {
            color: #201E67;
            font-size: 13px;
            margin-bottom: -1px;
            @media (max-width: 600px) {
                font-size: 12px;
            }
        }
    }
    .column-flex {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        gap: 16px;
    }
    .border-bottom {
        border-bottom: 1px solid #CCCCCC;
        padding-bottom: 16px;
    }
    .border-top {
        border-top: 1px solid #CCCCCC;
        padding-top: 16px;
    }
    .price-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        gap: 16px;
    }
    .item {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
    }
    .wage-desc {
        margin-top: -10px;
        color: #61788E;
        font-size: 12px;
        font-weight: 400;
        line-height: 24px;
        @media (max-width: 600px) {
            font-size: 11px;
        }
    }
    .failed-header {
        color: #DB3737;
    }
    .payment-desc {
        margin-top: -10px;
        color: #8A5E09;
        font-size: 14px;
        font-weight: 400;
        line-height: 28px;
        background-color: #FEF3C7;
        border-radius: 8px;
        padding: 8px;
        @media (max-width: 600px) {
            font-size: 13px;
        }
    }
    .failed-desc {
        color: #DB3737;
        background-color: #FEE2E2;
        margin-top: 10px;
    }
    .label {
        font-weight: 500;
        color: #61788E;
        font-size: 14px;
        @media (max-width: 600px) {
            font-size: 13px;
        }
        @media (max-width: 361px) {
            font-size: 12px;
        }
    }
    .value {
        font-weight: 500;
        color: #0D2439;
        font-size: 14px;
        text-align: left;
        @media (max-width: 600px) {
            font-size: 13px;
        }
        @media (max-width: 361px) {
            font-size: 12px;
        }
    }
    .content {
        .value {
            width: 50%;
            ${p => p.webConfig.dir === 'ltr' && `
                text-align: right;
            `}
        }
        .label {
            width: 50%;
        }
    }
    .summary {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 16px;
        width: 100%;
        margin-top: 5px;
    }
    .header {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        width: 100%;
        .img {
            border-radius: 50%;
            object-fit: cover;
        }
        .text-section {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
            .name {
                font-weight: 700;
                color: #0D2439;
                font-size: 14px;
            }
            .type {
                font-weight: 500;
                color: #61788E;
                font-size: 14px;
                @media (max-width: 600px) {
                    font-size: 13px;
                }
            }
        }
    }
    .content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 10px;
        width: 100%;
    }    
    .address {
        gap: 3px;
        border-bottom: 1px solid #CCCCCC;
        padding-bottom: 16px;
        align-items: flex-start;
    }
    .add-value {
        text-align: right;
        ${p => p.webConfig.dir === 'ltr' && `
            text-align: left;
        `}
    }
`

export const ProfileWrapper = styled.div`
    margin: auto;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    width: 464px;
    @media (max-width: 600px) {
        width: 100%;
    }
    .title {
        color: #0D2439;
        font-size: 18px;
        font-weight: 700;
        @media (max-width: 600px) {
            font-size: 17px;
        }
    }
    .inputs {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 15px;
        .input {
            width: 100%;
            height: auto;
        }
    }
    .book-button {
        height: 48px;
        width: 100%;
        border-radius: 8px;
        margin-top: 10px;
    }
`

export const ProfilesWrapper = styled.div `
    width: 500px;
    height: auto;
    margin: auto;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    @media (max-width: 600px) {
       width: 100%;
    }
    .title {
        color: #0D2439;
        font-size: 20px;
        font-weight: 700;
        @media (max-width: 600px) {
            font-size: 19px;
        }
    }
    .profile-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background: white;
        width: 100%;
        border-radius: 16px;
        padding: 10px 15px;
    }
    .column-flex {
        display: flex;
        flex-direction: column;
        gap: 5px;
        justify-content: center;
        align-items: flex-start;
        width: 90%;
    }
    .row-flex {
        display: flex;
        flex-direction: row;
        gap: 5px;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-bottom: 20px;
    }
    .text {
        color: #61788E;
        font-size: 16px;
        font-weight: 500;
        @media (max-width: 600px) {
            font-size: 15px;
        }
    }
    .icon {
        color: rgb(32, 30, 103);
        width: 20px;
        height: 20px;
        cursor: pointer;
    }
    .add-button {
        color: #29BCAB;
        font-size: 15px;
        font-weight: 500;
        width: auto;
        margin-bottom: 0;
        border: 1px solid #29BCAB;
        border-radius: 40px;
        padding: 5px 10px;
        cursor: pointer;
        @media (max-width: 600px) {
            font-size: 14px;
        }
        .icon {
            width: 17px;
            height: 17px;
            color: #29BCAB;
        }
    }
`

export const FilteringWrapper = styled.div`
    .row-flex {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 5px;
        width: 100%;
    }
    .column-flex {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 8px;
        width: 100%;
    }
    .m-t-20 {
        margin-top: 20px;
    }
    .item-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 5px;
        width: 100%;
        row-gap: 8px;
    }
    .flex-start {
        justify-content: flex-start !important;
    }
    .item {
        width: auto;
        padding: 5px 10px;
        border: 1px solid #61788E;
        border-radius: 8px;
        cursor: pointer;
        color: #61788E;
        &:hover {
            border: 1px solid rgb(41, 188, 171);
            color: rgb(41, 188, 171);
        }
    }
    .clear-filter {
        border: 1px solid red;
        background: white;
        color: red;
    }
    .button {
        width: 50%;
    }
    .state-container {
    }
`